module.exports = __webpack_public_path__ + "media/MarcusUniverseShowreel2022.cab71495.mp4";